import { render, staticRenderFns } from "./AuctionListDescription.vue?vue&type=template&id=7edda1fa&"
import script from "./AuctionListDescription.vue?vue&type=script&lang=js&"
export * from "./AuctionListDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports